import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: null
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setDashboardData: (state, action) => {
      state.data = action.payload
    },
    resetDashboard: state => {
      return initialState
    }
  }
})

export const { setDashboardData, resetDashboard } = dashboardSlice.actions

export default dashboardSlice.reducer
